import { SpinRequestPayload } from "slotworks/model/gameplay/requests/spin-request-payload";

export class PartnerConnectSpinRequestPayload extends SpinRequestPayload {
    public type: "play" | "collect" | "restore" | "history";
    public cmd: string;
    public mode: string;
}
